module.exports = __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmSU5fBBc4.ef7c6637.woff2";